import * as actions from "../global/actionTypes";

function action(type, payload = {}) {
  return { type, ...payload };
}

export const fetchJob = {
  request: (endpoint, jobId) =>
    action(actions.FETCH_JOB_REQUEST, { endpoint, jobId }),
  success: (jobId, response) =>
    action(actions.FETCH_JOB_SUCCESS, { jobId, response }),
  failure: (jobId, error) =>
    action(actions.FETCH_JOB_FAILURE, { jobId, error }),
};

export const fetchJobRequest = (endpoint, jobId) =>
  fetchJob.request(endpoint, jobId);
